import React from "react";
import "./LoadingOverlay.css";

function LoadingOverlay({ show = false, text = "Loading..." }) {
  if (!show) return null;
  return (
    <div className="lo-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="lo-panel">
        <div className="lo-spinner" aria-hidden="true"></div>
        <div className="lo-text">{text}</div>
      </div>
    </div>
  );
}

export default LoadingOverlay;